<template>
  <div class="login">
    <section class="cover">
      <div class="content">
        <h2 class="heading">Redirecting to Microsoft Login Api......</h2>
        <div class="cta-btn"></div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "login",
  components: {},
  data() {
    return {
      msg: "Signing in..."
    };
  },
  async created() {
    if (this.$msal.isAuthenticated()) {
      this.$router.push("/");
    }
    if (!this.$msal.isAuthenticated()) {
      this.$msal.signIn();
    }
  },
  methods: {
    async getUserInfo() {
      let res = await this.$graphApi.get(`me`, {
        params: {
          "api-version": 1.6
        }
      });
      console.log(res);
      return res.data;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/pages/Login.vue